<template>
  <b-card
    img-alt="Profile Cover Photo"
    img-top
    class="card-profile"
    border-variant="primary"
    bg-variant="transparent"
  >
    <!----<h3 @click="salesCustomer()" v-b-modal.modal-tall>{{ transaction.subcustomer.name }}</h3> --->
    <h3>{{ transaction.subcustomer.name }}</h3>
    <h6 class="text-muted">
      <feather-icon icon="SmartphoneIcon" /> {{ transaction.subcustomer.checkout_cpf_cnpj }}  <feather-icon icon="FolderIcon" /> {{ transaction.subcustomer.checkout_phone }}  <feather-icon icon="MailIcon" /> {{ transaction.subcustomer.checkout_email }}
    </h6>
    <b-badge
      class="profile-badge"
      variant="light-primary"
    >
      {{ transaction.payment.name }}
    </b-badge>

    <b-badge
      class="profile-badge"
      variant="light-primary"
    >
      {{ transaction.status.name }}
    </b-badge>

    <div>
      <h5 class="mb-0">
        <app-collapse>
          <app-collapse-item title="Produtos">
            <li v-for="item in transaction.product">
              <a
                :href=" store.url + item.link"
                target="_blank"
              >{{ item.name }}</a>
            </li>
          </app-collapse-item>
        </app-collapse>
      </h5>
    </div>
    <hr class="mb-2">
    <!-- follower projects rank -->
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h6 class="text-muted font-weight-bolder">
          número do pedido
        </h6>
        <h3 class="mb-0">
          {{ transaction.platform_id }}
        </h3>
      </div>
      <div>
        <h6 class="text-muted font-weight-bolder">
          Último Aprovado
        </h6>
        <h3
          v-if="transaction.order_approved"
          class="mb-0"
        >
          {{ transaction.order_approved.start_date }}
        </h3>
        <h3
          v-else
          class="mb-0"
        >
          ---
        </h3>
      </div>
    </div>
    <!--/ follower projects rank -->

    <hr class="mb-2">
    <!-- follower projects rank -->
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h6 class="text-muted font-weight-bolder">
          Total
        </h6>
        <h3 class="mb-0">
          R$ {{ transaction.amount }}
        </h3>
      </div>
      <div>
        <h6 class="text-muted font-weight-bolder">
          Cupom utilizado
        </h6>
        <h3 class="mb-0">
          {{ transaction.coupon }}
        </h3>
      </div>
    </div>
    <!--/ follower projects rank -->

    <hr class="mb-2">
    <b-button
      block
      variant="success gradient"
      @click="contact(transaction.subcustomer.checkout_phone)"
    >
      Contatar
    </b-button>

    <b-button
      v-if="transaction.bar_code_link"
      variant="primary gradient"
      @click="copy(transaction.bar_code_link)"
    >
      Boleto
    </b-button>

    <b-button
      v-if="transaction.platform_id && transaction.status_id === 12"
      variant="primary gradient btn-icon"
      @click="getLinkCart(transaction.platform_id)"
    >
      <feather-icon icon="ShoppingCartIcon" />
      Link Carrinho
    </b-button>

    <b-button
      v-b-modal.modal-select2
      variant="warning gradient"
      class="btn-icon"
      @click="scheduleSubattending(subattending)"
    >
      <feather-icon icon="CalendarIcon" />
      Agendar
    </b-button>

  </b-card>
</template>

<script>
import {
  BCard, BAvatar, BBadge, BButton, BModal, VBModal,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import schedule from '../../schedule/editSchedule.vue'
import magazord from '../../../functions/basics/magazord'

export default {
  emits: ['scheduleSubattending'],
  components: {
    BCard,
    BBadge,
    BAvatar,
    BButton,
    AppCollapseItem,
    AppCollapse,
    schedule,
    BModal,
    VBModal,
  },
  props: {
    transaction: Object,
    store: Object,
    app: Boolean,
    subattending: Object,
  },
  methods: {
    copy(info) {
      // Copy the text inside the text field
      navigator.clipboard.writeText(info)
    },
    async contact(phone) {
      const url = (this.app) ? 'whatsapp://send?phone=' : 'https://web.whatsapp.com/send?phone='

      window.open(encodeURI(`${url}55${phone}`), '_blank')
    },
    scheduleSubattending(transaction) {
      this.$emit('scheduleSubattending', transaction)
      console.log(transaction)
    },
    async salesCustomer() {
      const cpf = this.transaction.subcustomer.checkout_cpf_cnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      const sales = await magazord.getSales(this.store, cpf)
      this.$emit('salesCustomer', sales.data.items)
      console.log(sales)
    },
    async getLinkCart(cartId) {
      const linkCart = await magazord.getLinkCart(this.store.uuid, cartId).then(response => {
        navigator.clipboard.writeText(response)

        this.$swal({
          position: 'bottom-end',
          icon: 'success',
          title: 'O link do carrinho foi copiado!',
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }).catch(err => console.log(err))
    },
  },
}
</script>
